import React, { useCallback, useEffect, useState } from 'react';
import Modal from '../modal';
import { customEmojis } from '../../constants/dropdown';
import Avatar from '../../assets/images/avatar-placeholder.png';
import { useAuth } from '../../context/auth/auth-context';

interface LikesModalProps {
    isOpen: boolean;
    onClose: () => void;
    data: any;
    groupedEmoticons: any;
    activeTab?: string;
}

const nameAttributes: any = {
    'all': 'All',
    '1f389': 'Celebration',
    '1f44d': 'Like',
    '1f31f': 'Excellent',
    '1f973': 'Cheer',
    '2764-fe0f': 'Heart',
}

const LikesModal: React.FC<LikesModalProps> = ({ isOpen, onClose, data, groupedEmoticons, activeTab }) => {
    const { auth } = useAuth();
    const { user } = auth;

    const [activeTabState, setActiveTabState] = useState<any>('all');
    const handleTabClick = useCallback((id: string) => {
        setActiveTabState(id);
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (isOpen) {
            setActiveTabState(activeTab ? activeTab : 'all');
        }
    }, [isOpen, activeTab]);

    const allUsers = Array.isArray(groupedEmoticons)
        ? groupedEmoticons.flatMap((group: any) => group.users || [])
        : [];

    const allTab = {
        id: 'all',
        emoticon: 'all',
        count: allUsers.length,
        users: allUsers,
    };

    const tabs = [allTab, ...(Array.isArray(groupedEmoticons) ? groupedEmoticons : [])];

    const findTab: any = tabs.find((item: any) => item.emoticon === activeTabState);
    return (
        <Modal isOpen={isOpen} onClose={onClose} size="xxs" className={"h-[60vh]"}>
            <div>
                <div className={`flex border-b gap-4`}>
                    {Array.isArray(tabs) && tabs.map((tab: any) => {
                        return (
                            <button
                                key={tab.id + tab.emoticon}
                                onClick={() => handleTabClick(tab.emoticon)}
                                className={`py-2 font-aeonikMedium relative ${activeTabState === tab.emoticon
                                    ? "text-primary  active-tab"
                                    : "text-[#707479] hover:text-primary"
                                    }`}
                            >
                                <span className='flex flex-row items-center'>
                                    {tab.emoticon !== 'all' ? <img src={customEmojis.find((emoji: any) => emoji.unified === tab.emoticon)?.image} alt={tab.emoticon} className="w-4 h-4" /> : null}
                                    <span className='pl-1 text-sm'> {nameAttributes[tab.emoticon]}</span>
                                </span>
                            </button>
                        )
                    })}
                </div>
                {/* Render count */}
                {findTab?.emoticon ? <div className='font-aeonikMedium p-1'>{`${nameAttributes[findTab?.emoticon]} (${findTab.count})`}</div> : null}
                {/* Render Data */}
                <div className='overflow-y-auto h-[45vh]'>
                    {findTab?.users?.length > 0 ?
                        findTab?.users?.map((item: any, index: number) => {
                            // return < div key={index} className='p-1.5'>
                            //     <div className={`flex flex-row items-center`}>
                            //         <img src={customEmojis.find((emoji) => emoji.unified === item.emoticon)?.image} alt={item.emoticon} className="w-5 h-5" />
                            //         <div className='flex flex-col ml-2 avatar-content'>
                            //             <div className={` flex text-labelTextCol  text-sm font-aeonikReg avatar-heading`} title={item.name}>{item.name}
                            //             </div>
                            //         </div>
                            //     </div>
                            // </div>

                            return <div className="flex items-center space-x-2 p-1.5">
                                <div className="relative">
                                    <img
                                        src={item?.personal_image || Avatar} // Replace with actual image path
                                        alt="Shahid Ali"
                                        className="w-8 h-8 rounded-md object-cover"
                                    />
                                    <span className="absolute -bottom-1 -right-1 bg-white rounded-full p-1 bg-[#F5F0E8]">
                                        <span>
                                            <img src={customEmojis.find((emoji) => emoji.unified === item.emoticon)?.image} alt={item.emoticon} className="w-3 h-3" />
                                        </span>
                                    </span>
                                </div>
                                <div className='flex flex-col ml-2 avatar-content'>
                                    <div className={` flex text-labelTextCol  text-sm font-aeonikReg avatar-heading`} title={item.name}>{item?.id === user?.id ? "You" : item?.name}
                                    </div>
                                </div>
                            </div>
                        })
                        : null}
                </div>
            </div>
        </Modal >
    );
};

export default React.memo(LikesModal);